import { render, staticRenderFns } from "./InputTask.vue?vue&type=template&id=0fe64d58&scoped=true"
import script from "./InputTask.vue?vue&type=script&lang=ts"
export * from "./InputTask.vue?vue&type=script&lang=ts"
import style0 from "./InputTask.vue?vue&type=style&index=0&id=0fe64d58&prod&last=scss&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe64d58",
  null
  
)

export default component.exports